import { Stack, Text, Title, useMantineTheme } from '@mantine/core'
import { useMediaQuery } from '@mantine/hooks'
import sha256 from 'crypto-js/sha256'
import React, { useMemo } from 'react'
import { Link } from 'react-router-dom'

import { RichText } from '@/plugins/contentful/api'

import Loading from '../Loading'
import ImageWrapper from '../MediaWrappers/ImageWrapper'

export const truncate = (str: string, size: number = 85) =>
  str.length > size ? `${str.substring(0, size)}...` : str

export interface GalleryElement {
  id: string
  title: string
  paragraph: string
  description: RichText | string
  image: string | undefined
  downloadLink?: string
  techRequirements?: {
    [key: string]: string
  }
  buttonLink: string
  buttonText?: string
  isSpaces?: boolean
  leaderboard?: boolean
  signedOut?: boolean
  signedIn?: boolean
}

interface GalleryCardProps {
  elem: GalleryElement
}

const GalleryCard: React.FC<GalleryCardProps> = ({ elem }) => {
  const theme = useMantineTheme()
  const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`)
  const hash = useMemo(() => sha256(JSON.stringify(elem)).toString().substring(0, 8), [elem])

  return (
    <>
      {elem && (
        <Stack style={{ width: '300px' }}>
          <Link
            to={elem.isSpaces ? `/spaces/${elem.id}` : `/discover/${hash}`}
            state={elem}
            style={{ textDecoration: 'none' }}
          >
            {typeof elem.image === 'string' ? (
              <ImageWrapper
                src={elem.image}
                style={{ height: '300px', width: '300px', borderRadius: '6px' }}
                alt={`image_${elem.id}`}
              />
            ) : (
              <Loading imageLoaderHeight="300px" />
            )}
            <Title
              order={4}
              style={{
                textAlign: 'left',
                fontSize: '18px',
                minHeight: isMobile ? '0' : '55px',
                marginTop: '8px',
                marginBottom: '8px',
              }}
            >
              {elem.title}
            </Title>
            <Text style={{ fontSize: '14px' }}>{truncate(elem.paragraph)}</Text>
          </Link>
        </Stack>
      )}
    </>
  )
}

export default GalleryCard
